import { QueryOrigin, TrackingState } from '../../models';

export function getInitialTrackingState(): TrackingState {
  return {
    productPageResultId: undefined,
    resultsEnd: false,
    queryOrigin: QueryOrigin.default
  };
}
